export default "__VITE_ASSET__5nBqW6v8__"